import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchAffinity } from '../../../../shared/affinity';
import { GlobalState, Thunk } from '../../../types.global';
import * as actions from './actions';
import { VeveBanner } from './types';

const getBanners = (userId: string) => fetchAffinity(userId, {
  n: '1',
  ist: '1',
  bs: '300x250',
});

type AdTilesResult = { list: VeveBanner[]; savedAt: number };

export const fetchBanners = createAsyncThunk(
  'banners/fetchBanners',
  async (data, thunkAPI): Promise<AdTilesResult> => {
    const state = thunkAPI.getState() as GlobalState;
    const list = await getBanners(state.user.userId) as VeveBanner[];
    return { list, savedAt: Date.now() };
  }
);

export const clickedAd = (): Thunk => (dispatch) => {
  dispatch(actions.clickedAd());
};

export const disabledBanner = (value: 'day' | 'forever'): Thunk => (dispatch) => {
  const endOfDay = new Date();
  endOfDay.setHours(23, 59, 59, 999);

  dispatch(actions.disabledUntil(value === 'day' ? Number(endOfDay) : -1));
};